/** Default column config for dropped inventory table (inventory + report). */
export const DEFAULT_DROPPED_INVENTORY_TABLE_COLUMNS = [
  { label: 'Size', flex: 0.6, show: true, object: 'size' },
  { label: 'SSL', flex: 0.7, show: true, object: 'ssl' },
  {
    label: 'Container #',
    flex: 1.1,
    show: true,
    object: 'name',
    hasLink: true,
  },
  { label: 'Chassis #', flex: 0.7, show: true, object: 'chases' },
  { label: 'Gated Out', flex: 0.9, show: true, object: 'gated_out' },
  { label: 'Gated In', flex: 0.9, show: true, object: 'gated_in' },
  { label: 'Billed To', flex: 1.1, show: false, object: 'billed_to' },
  { label: 'Delivery Site', flex: 1.1, show: false, object: 'delivery_site' },
  { label: 'Delivery City', flex: 1.1, show: false, object: 'delivery_city' },
  {
    label: 'Delivery Zipcode',
    flex: 1,
    show: false,
    object: 'delivery_zipcode',
  },
  {
    label: 'Delivery Apt Time',
    flex: 1.1,
    show: false,
    object: 'delivery_apt_time',
  },
  { label: 'Delivery Type', flex: 1, show: false, object: 'delivery_type' },
  {
    label: 'Loadout Terminal',
    flex: 1.3,
    show: false,
    object: 'pickup_appointment',
  },
  { label: 'Empty Location', flex: 0.7, show: true, object: 'loc' },
  {
    label: 'Return Appointment',
    flex: 1.8,
    show: true,
    object: 'return_appointment',
  },
  {
    label: 'Single Transaction',
    flex: 0.9,
    show: true,
    object: 'return_terminals',
  },
  {
    label: 'Dual Only Transaction',
    flex: 0.9,
    show: true,
    object: 'return_dual_terminals',
  },
  { label: 'LFD', flex: 0.7, show: true, object: 'last_free_day' },
  { label: 'Est. PerDiem', flex: 0.7, show: true, object: 'est_per_diem' },
  { label: 'Chassis Type', flex: 0.6, show: true, object: 'own_chases' },
  { label: 'Available Date', flex: 0.9, show: false, object: 'date' },
  { label: 'Last Import', flex: 0.9, show: false, object: 'added_date' },
  { label: 'Last Update', flex: 0.9, show: true, object: 'last_update' },
];

export const resolveDroppedTableColumnsFromSettings = (res) => {
  const fromApi =
    res?.data?.settings?.data ?? res?.settings?.data ?? null;

  return Array.isArray(fromApi) && fromApi.length > 0 ? fromApi : null;
};
